import { useEffect } from "react";
import styles from "./FailurePage.module.css";
import axios from "axios";

function FailurePage() {
//   useEffect(() => {
//     document.body.style.background = "#fff5f5";
//   }, []);

const printLogs=async()=>{
  try {
    console.log(window.location.href,'pah');
    const response=await axios.post('/print-logs',{
      request:"HE Failure Page Logs",
      response:window.location.href
    })
    console.log(response,'response-');
  } catch (error) {
    console.log(error,'error-');
  }
}

useEffect(()=>{
  printLogs();
},[]);  

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.icon}>❌</div>
        <h1 className={styles.title}>Subscription Failed</h1>
        <p className={styles.text}>
          Something went wrong. Please try again or check your details.
        </p>

        <button
          className={styles.retryButton}
          onClick={() => (window.location.href = "/home")}
        >
          Try Again
        </button>
      </div>
    </div>
  );
}

export default FailurePage;